/*
  价格监控
  @date 2021-03-11
  @author wanghui@gwdang.com
 */

import Utils from '../js/utils/utils';

const PriceMonitor = {
    /**
     * 检查url合法性
     * @param url
     */
    checkUrl (url) {
        url = url.trim();
        if (url) {
            const options = {
                isSign: false,
                crossDomain: true,
            };
            return new Promise((resolve, reject) => {
                Utils.HttpRequest.post('/monitor/add', {
                    action: 'checkUrl',
                    url: url
                }, options, (response) => {
                    if (! response.code) {
                        return resolve(response.data);
                    }

                    return reject('error url');
                })
            });
        }

        return Promise.reject('error url');
    },

    submit (data) {
        const options = {
            isSign: false,
            crossDomain: true,
        };
        return new Promise ((resolve, reject) => {
            Utils.HttpRequest.post('/monitor/add', data, options, (response) => {
                if (! response.code) {
                    return resolve(response.data);
                }

                return reject({
                    validated: response.code,
                    msg: response.code == -2 ? '验证码错误' : ''
                });
            });
        })
    }
};

export default PriceMonitor;